/** 
 * @type {import("./defs").StorePlanReport} 
 */ 
 const store = { 
 } 
 /** 
 * @returns {import("./defs").StorePlanReport} 
 */ 
 export default function () { 
 return JSON.parse(JSON.stringify(store)); 
 }


// WEBPACK FOOTER //
// ./resources/js/storers/StorePlanReport.js